import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-17 fs-1"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 0,
  class: "row fs-4 text-center mb-5 mt-3"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"5px","background-color":"#ffecec","color":"#9f005b","border-radius":"10px"} }, " Total Value Exceed Base Schema ", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "mt-5 mb-5 d-flex justify-content-end align-items-center" }
const _hoisted_7 = { class: "d-flex align-items-center w-300px" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-150px" }, "Base Schema", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_10 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_11 = { class: "text-muted text-uppercase" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", null, "Source Uid", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", null, "Target Uid", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, "Rebate Name", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, "Update On", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", null, "Create On", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", null, "Action", -1)
const _hoisted_18 = {
  key: 0,
  style: {"height":"150px"}
}
const _hoisted_19 = { colspan: "12" }
const _hoisted_20 = {
  key: 1,
  style: {"height":"150px"}
}
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = {
  key: 1,
  class: "mb-5"
}
const _hoisted_26 = { style: {"border":"1px dashed #ccc","padding":"15px","border-radius":"5px"} }
const _hoisted_27 = { class: "card-body py-4" }
const _hoisted_28 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_29 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_30 = { class: "" }
const _hoisted_31 = { class: "" }
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "" }
const _hoisted_34 = { class: "" }
const _hoisted_35 = { class: "cell-color" }
const _hoisted_36 = { class: "cell-color" }
const _hoisted_37 = { class: "text-center" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 1 }
const _hoisted_40 = {
  key: 2,
  class: "fw-semibold text-gray-900"
}
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = {
  key: 1,
  class: "typeBadge"
}
const _hoisted_44 = { class: "cell-color" }
const _hoisted_45 = { class: "cell-color" }
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 2,
  class: "mb-5"
}
const _hoisted_49 = { style: {"border":"1px dashed #ccc","padding":"15px","border-radius":"5px"} }

import { ref, onMounted, inject } from "vue";
import { useStore } from "@/store";
import AccountService from "../services/AccountService";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import RebateService from "../../rebate/services/RebateService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import DirectRebateForm from "./form/DirectRebateForm.vue";
import { useRoute } from "vue-router";
import SearchFilter from "@/components/SearchFilter.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { Search } from "@element-plus/icons-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRebateDirect',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;



const accountDetails = ref({});
const route = useRoute();
const rebateType = ref("");
const showAddRebateRuleForm = ref(false);
const showTargetAccountSearch = ref(true);
const fromRebateRuleDetailId = ref(-1);
const selectedTargetAccount = ref({});
const store = useStore();
const isLoading = ref(true);
const tableData = ref(Array<any>());
const user = ref(store.state.AuthModule.user);
const accountInfo = ref({} as any);
const showSchemaTotalError = ref(false);
const searchList = ref(Array<any>());
const criteria = ref<any>({
  page: 1,
  SourceAccountId: accountDetails.value.id,
});

const showListCriteria = ref<any>({
  page: 1,
  pageSize: 20,
  searchText: "",
});
const baseSchemaInfo = ref<any>({
  loading: false,
  id: "",
});
const openConfirmModal = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);
// const handleSearchTradeAccount = ref((q: string) =>
//   AccountService.fuzzySearchAccountByCriteria({
//     keywords: q,
//     // hasTradeAccount: true,
//   })
// );
const clearSearchResult = () => {
  searchList.value = [];
  fromRebateRuleDetailId.value = -1;
  showAddRebateRuleForm.value = false;
  showTargetAccountSearch.value = true;
};

// const showTargetAccounts = async (results: { ids: any; criteria: any }) => {
//   const res = await AccountService.queryAccounts({
//     ids: results.ids,
//   });

//   searchList.value = res.data;
// };

const showRebateRuleDetail = async (_id: any) => {
  showAddRebateRuleForm.value = false;
  showTargetAccountSearch.value = true;

  fromRebateRuleDetailId.value = _id;

  const res1 = await RebateService.getRebateDirectRuleById(_id);
  const res2 = await AccountService.queryAccounts({
    id: res1.targetAccountId,
  });
  selectedTargetAccount.value = res2.data[0];

  showAddRebateRuleForm.value = true;
  showTargetAccountSearch.value = false;
};
const changeTargetAccountFn = () => {
  showAddRebateRuleForm.value = false;
  showTargetAccountSearch.value = true;
};
const selectTargetAccountFn = (_item: any) => {
  selectedTargetAccount.value = _item;
  showAddRebateRuleForm.value = true;
  showTargetAccountSearch.value = false;
};
const calculateBaseSchema = async (_schemas: []) => {
  const compareData = ref({} as any);
  if (!accountDetails.value.tradeAccount?.rebateBaseSchemaId) return;
  const baseSchema = await RebateService.getRebateBaseSchemaById(
    accountDetails.value.tradeAccount.rebateBaseSchemaId
  );

  baseSchema.rebateBaseSchemaItems.forEach(function (item) {
    compareData.value[item.symbolCode] = {
      rate: item.rate,
      pips: item.pips,
      commission: item.commission,
    };
  });

  try {
    _schemas.forEach(async (id) => {
      const res = await RebateService.getRebateSchema(id);
      for (let item of res.rebateDirectSchemaItems) {
        compareData.value[item.symbolCode].rate =
          compareData.value[item.symbolCode].rate - item.rate;
        compareData.value[item.symbolCode].pips =
          compareData.value[item.symbolCode].pips - item.pips;
        compareData.value[item.symbolCode].commission =
          compareData.value[item.symbolCode].commission - item.commission;
        if (
          compareData.value[item.symbolCode].rate < 0 ||
          compareData.value[item.symbolCode].pips < 0 ||
          compareData.value[item.symbolCode].commission < 0
        ) {
          showSchemaTotalError.value = true;
          // MsgPrompt.warning("Total rebate exceed base schema!");
          break;
        } else {
          showSchemaTotalError.value = false;
        }
      }
    });
  } catch (error) {
    MsgPrompt.error(error);
  }
};
const openConfirmDirectRebateRuleModal = (_item) => {
  openConfirmModal?.(
    () =>
      RebateService.putConfirmDirectRebateRule(_item.id)
        .then(() => MsgPrompt.success("Confirm successfully!"))
        .then(() => fetchData(1)),
    void 0,
    {
      confirmText: "Are you sure to confirm this direct rebate rule?",
      confirmColor: "info",
    }
  );
};

const deleteRebateRule = async (_id: any) => {
  MsgPrompt.warning("Are you sure to delete?").then(async (result) => {
    /* Read more about isConfirmed, isDenied below */
    if (result.isConfirmed) {
      try {
        await RebateService.deleteRebateDirectRuleById(_id);
        showAddRebateRuleForm.value = false;
        showTargetAccountSearch.value = true;
        refresh();
      } catch (error) {
        MsgPrompt.error(error);
      }
    }
  });
};

const refresh = () => {
  fetchData(criteria.value.page);
};

const fetchSearchList = async (_page: number) => {
  isLoading.value = true;
  showListCriteria.value.page = _page;
  try {
    const res = await AccountService.queryAccounts(showListCriteria.value);
    searchList.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;
  criteria.value.SourceAccountId = accountDetails.value.id;

  try {
    const responseBody = await RebateService.getRebateDirectRule(
      criteria.value
    );

    const temp = await AccountService.queryAccounts({
      id: accountDetails.value.id,
    });
    accountInfo.value = temp.data[0];

    criteria.value = responseBody.criteria;
    tableData.value = responseBody.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }

  const schemaList = ref([] as any);
  tableData.value.forEach((item) => schemaList.value.push(item.rebateRuleId));
  calculateBaseSchema(schemaList.value);
};

const setBaseSchema = async () => {
  try {
    await RebateService.putClientBaseSchema(
      accountDetails.value.id,
      baseSchemaInfo.value.id
    );
  } catch (error) {
    MsgPrompt.error(error);
  }
};

const setupDropdownOptions = async () => {
  const resRebate = await RebateService.getBaseSchemaList();
  baseSchemaInfo.value["list"] = resRebate.data;
  baseSchemaInfo.value.id = baseSchemaInfo.value["list"].find(
    (item) =>
      item.value === accountDetails.value.tradeAccount?.rebateBaseSchemaId
  )?.key;
};

onMounted(async () => {
  isLoading.value = true;
  searchList.value = [];
  showAddRebateRuleForm.value = false;
  showTargetAccountSearch.value = true;

  accountDetails.value = props.accountDetails;
  rebateType.value =
    props.accountDetails.rebateClientRule.distributionType.toString();

  if (route.query.accountId) {
    accountDetails.value = await AccountService.getAccountDetailById(
      parseInt(route.query.accountId as string)
    );
  }

  // if (accountDetails.value.rebateClientRule.schema == "{}") {
  //   pipCommissionDecision.value = {
  //     commission: 0,
  //     pips: 0,
  //   };
  // } else {
  //   console.log("schema", accountDetails.value.rebateClientRule.schema);
  //   pipCommissionDecision.value = JSON.parse(
  //     accountDetails.value.rebateClientRule.schema
  //   ).find((obj) => obj.accountType === accountDetails.value.type);
  // }

  await fetchData(1);
  await setupDropdownOptions();
  if (route.query.rebateId) {
    await showRebateRuleDetail(parseInt(route.query.rebateId as string));
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_IbSalesInfo = _resolveComponent("IbSalesInfo")!

  return (!accountDetails.value.hasTradeAccount)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Client has no trade account ! "))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (showSchemaTotalError.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_select, {
              modelValue: baseSchemaInfo.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((baseSchemaInfo.value.id) = $event)),
              placeholder: "Select Base Schema",
              onChange: setBaseSchema
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseSchemaInfo.value.list, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.key,
                    value: item.value
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _hoisted_9,
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_11, [
              _hoisted_12,
              _hoisted_13,
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.confirmedBy")), 1),
              _hoisted_17
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_19, [
                    _createVNode(ScaleLoader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && tableData.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                _createVNode(_component_NoDataBox)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(item.sourceAccount.accountNumber), 1),
                _createElementVNode("td", null, _toDisplayString(item.targetAccountUid), 1),
                _createElementVNode("td", null, _toDisplayString(item.rebateRuleName), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_TimeShow, {
                    "date-iso-string": item.updatedOn
                  }, null, 8, ["date-iso-string"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_TimeShow, {
                    "date-iso-string": item.createdOn
                  }, null, 8, ["date-iso-string"])
                ]),
                _createElementVNode("td", null, _toDisplayString(item.createdByName), 1),
                _createElementVNode("td", null, [
                  (item.confirmedByName !== '')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(item.confirmedByName), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: "btn btn-light btn-info btn-sm me-3",
                        disabled: user.value.name === item.createdByName,
                        onClick: ($event: any) => (openConfirmDirectRebateRuleModal(item))
                      }, _toDisplayString(_ctx.$t("action.confirm")), 9, _hoisted_21))
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-light btn-success btn-sm me-3",
                    onClick: ($event: any) => (showRebateRuleDetail(item.id))
                  }, _toDisplayString(_ctx.$t("action.details")), 9, _hoisted_22),
                  _createElementVNode("button", {
                    class: "btn btn-light btn-danger btn-sm me-3",
                    onClick: ($event: any) => (deleteRebateRule(item.id))
                  }, _toDisplayString(_ctx.$t("action.delete")), 9, _hoisted_23)
                ])
              ]))
            }), 128))
          ])
        ]),
        _hoisted_24,
        (showTargetAccountSearch.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_el_input, {
                  modelValue: showListCriteria.value.searchText,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showListCriteria.value.searchText) = $event)),
                  placeholder: "Please input keywords",
                  class: "w-400px",
                  clearable: ""
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      icon: _unref(Search),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (fetchSearchList(1)))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("table", _hoisted_28, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_29, [
                        _createElementVNode("th", _hoisted_30, _toDisplayString(_ctx.$t("fields.user")), 1),
                        _createElementVNode("th", _hoisted_31, _toDisplayString(_ctx.$t("fields.role")), 1),
                        _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.$t("fields.group")), 1),
                        _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.$t("fields.type")), 1),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
                        _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("fields.ib")), 1),
                        _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.$t("fields.salesWithCode")), 1),
                        _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.$t("action.action")), 1)
                      ])
                    ]),
                    (isLoading.value)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_38, [
                          _createVNode(_component_LoadingRing)
                        ]))
                      : (!isLoading.value && searchList.value.length === 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                            _createVNode(_component_NoDataBox)
                          ]))
                        : (_openBlock(), _createElementBlock("tbody", _hoisted_40, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchList.value, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                _createElementVNode("td", _hoisted_41, [
                                  _createVNode(_component_UserInfo, {
                                    url: "#",
                                    user: item.user,
                                    class: "me-2"
                                  }, null, 8, ["user"])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.accountRole." + item.role)), 1),
                                _createElementVNode("td", null, _toDisplayString(item.group), 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.$t("type.account." + item.type)), 1),
                                _createElementVNode("td", null, [
                                  (item.role == 400)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(item.tradeAccount.accountNumber), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_43, "UID: " + _toDisplayString(item.uid), 1))
                                ]),
                                _createElementVNode("td", _hoisted_44, [
                                  _createVNode(_component_IbSalesInfo, {
                                    url: "#",
                                    user: item.agentAccount.user,
                                    uid: item.agentAccount.uid,
                                    class: "me-2"
                                  }, null, 8, ["user", "uid"])
                                ]),
                                _createElementVNode("td", _hoisted_45, [
                                  _createVNode(_component_IbSalesInfo, {
                                    url: "#",
                                    user: item.salesAccount.user,
                                    code: item.salesAccount.code,
                                    uid: item.salesAccount.uid,
                                    class: "me-2"
                                  }, null, 8, ["user", "code", "uid"])
                                ]),
                                _createElementVNode("td", _hoisted_46, [
                                  _createElementVNode("button", {
                                    class: "btn btn-light btn-success btn-sm me-3",
                                    onClick: ($event: any) => (selectTargetAccountFn(item))
                                  }, _toDisplayString(_ctx.$t("action.select")), 9, _hoisted_47)
                                ])
                              ]))
                            }), 128))
                          ]))
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (showAddRebateRuleForm.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _createVNode(DirectRebateForm, {
                  ref: "schemaDetailRef",
                  rebateType: rebateType.value,
                  accountDetails: accountDetails.value,
                  fromRebateRuleDetailId: fromRebateRuleDetailId.value,
                  targetAccount: selectedTargetAccount.value,
                  onChangeTargetAccountFn: changeTargetAccountFn,
                  onClearSearchResult: clearSearchResult,
                  onRefresh: refresh
                }, null, 8, ["rebateType", "accountDetails", "fromRebateRuleDetailId", "targetAccount"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
}
}

})